import { createHashHistory } from 'history';

const history = createHashHistory({ basename: window.location.pathname });

export default history;
